<template>
  <div class="page-mylist" :class="empty ? 'theme-white' : 'theme-blue'">
    <div class="mylist-list"
      v-infinite-scroll="getScenicList"
      infinite-scroll-immediate-check="false"
      infinite-scroll-disabled="loading"
      id="scroll_area_box"
      v-if="!empty"
      infinite-scroll-distance="0">
      <div
        class="list-item"
        v-for="(data, index) in scenicList"
        :key="index"
        >
        <div class="item-status">
          <img src="../assets/images/dsy.png" v-if="data.useStatus === 1">
          <img src="../assets/images/ysy.png" v-if="data.useStatus === 2">
          <img src="../assets/images/ygq.png" v-if="data.useStatus === 3">
        </div>
        <div class="item-filed">
          <div class="filed-name">{{data.siteName}}</div>
          <div class="filed-text" v-if="data.siteLevelName !== '未定级别'">{{data.siteLevelName}}</div>
        </div>
        <div class="item-filed">
          <div class="filed-text">地址：{{data.siteAddress}}</div>
        </div>
        <div class="item-filed">
          <div class="filed-text">预约时间：{{data.rdate + ' ' + data.time}}</div>
        </div>
        <div class="item-filed">
          <div class="filed-text">预约人：{{data.name}}</div>
        </div>
        <div class="status-cancel" v-if="data.useStatus === 4">
          <img src="../assets/images/yiquxiao@2x.png">
        </div>
        <div class="btn-cancel" role="button" v-if="data.useStatus === 1" @click="cancel(data, index)">取消预约</div>
        <div class="btn-qrcode" role="button" v-if="data.useStatus !== 4" @click="toStatus(data)">预约二维码</div>
      </div>
    </div>
    <div class="empty-box" v-if="empty">
      <img src="@/assets/images/empty@2x.png">
      <span>暂无预约</span>
    </div>
    <mt-popup v-model="cancelVisiable" class="cancelpop" pop-transition="popup-fade">
      <div class="cancel-box">
        <div class="box-content">
          确认取消预约？
        </div>
        <div class="box-bottom">
          <div class="bottom-item" @click="confirmCancel()">确认</div>
          <div class="bottom-item" @click="cancelVisiable = false">取消</div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script type="text/javascript">
import { Toast, Indicator } from 'mint-ui'
export default{
  data () {
    return {
      loading: false,
      allLoaded: false,
      start: 0,
      limit: 10,
      isFirst: true,
      cancelVisiable: false,
      scenicList: [],
      cancelObj: {},
      cancelIndex: 0,
      empty: false
    }
  },
  methods: {
    // 获取景区列表
    async getScenicList () {
      let that = this
      if (that.allLoaded) {
        that.loading = true
        return
      }
      that.loading = true
      try {
        Indicator.open()
        let result = await that.$api({
          method: 'get',
          url: '/user/myBooking',
          params: {
            start: that.start,
            limit: that.limit,
            type: -1,
            areaId: -1
          }
        })
        Indicator.close()
        if (result.code === 2000 && result.result) {
          let res = result.result
          let arr = res.info || []
          that.scenicList = [...that.scenicList, ...arr]
          if (that.scenicList.length === res.total) {
            that.allLoaded = true
          } else {
            that.start += that.limit
          }
          that.empty = !res.total
        } else {
          Toast({
            message: result.message,
            duration: 2000
          })
        }
      } catch (e) {
        Indicator.close()
        console.log(e)
      }
      that.loading = false
    },
    toTips (id) {
      this.$router.push({
        path: '/tips',
        query: {
          id: id
        }
      })
    },
    async toStatus (obj) {
      let that = this
      try {
        Indicator.open()
        let result = await that.$api({
          method: 'post',
          url: '/healthCode/verify',
          params: {
            credentialsType: 1,
            idCard: obj.idCard
          }
        })
        Indicator.close()
        if (result.code === 2000) {
          obj.mzt = result.result.mzt
          let _obj = {
            code: 2000,
            from: 'list',
            result: obj
          }
          that.setSession('status', _obj)
          that.$router.push({
            path: '/status'
          })
        } else {
          Toast({
            message: '获取不到您的健康码信息',
            duration: 2000
          })
        }
      } catch (e) {
        Indicator.close()
        Toast(e)
      }
    },
    cancel (obj, index) {
      this.cancelObj = obj
      this.cancelIndex = index
      this.cancelVisiable = true
    },
    async confirmCancel () {
      let that = this
      try {
        Indicator.open()
        let result = await that.$api({
          method: 'post',
          url: '/bookingSite/cancel',
          params: {
            id: that.cancelObj.id
          }
        })
        Indicator.close()
        if (result.code === 2000) {
          let _obj = that.scenicList[that.cancelIndex]
          _obj.useStatus = 4
          that.scenicList.splice(that.cancelIndex, 1, _obj)
        } else {
          Toast({
            message: result.message,
            duration: 2000
          })
        }
      } catch (e) {
        Indicator.close()
        Toast(e)
      }
      this.cancelVisiable = false
    }
  },
  mounted () {
    this.getScenicList()
    document.title = '我的预约'
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.page-mylist{
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .empty-box{
    width: 1.8rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1.54rem;
    img{
      width: 100%;
      height: 1.33rem;
    }
    span{
      font-size: .14rem;
      color: #999999;
      margin-top: .15rem;
    }
  }
  .mylist-list{
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    padding: .15rem;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    .list-item{
      width: 100%;
      height: 1.33rem;
      background: #FFFFFF;
      border: .01rem solid rgba(58,127,255,0.44);
      box-shadow: inset 0 .03rem .01rem .02rem rgba(58,127,255,0.45);
      border-radius: .04rem .04rem 0 0;
      overflow: hidden;
      border-radius: .06rem;
      box-sizing: border-box;
      padding: .15rem .15rem 0;
      position: relative;
      ~.list-item{
        margin-top: .1rem
      }
      .item-filed{
        width: 100%;
        min-height: .2rem;
        font-size: .14rem;
        color: #666666;
        display: flex;
        align-items: center;
        ~.item-filed{
          margin-top: .05rem;
        }
        .filed-name{
          font-weight: bold;
          margin-right: .09rem;
        }
      }
      .item-status{
        position: absolute;
        width: .64rem;
        height: .22rem;
        top: .15rem;
        right: 0;
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .btn-cancel{
        width: .9rem;
        height: .28rem;
        text-align: center;
        line-height: .28rem;
        height: .28rem;
        border: .01rem solid #7298FF;
        border-radius: .14rem;
        font-size: .12rem;
        color: #5EA0FF;
        font-weight: bold;
        background: #FFFFFF;
        position: absolute;
        bottom: .15rem;
        right: 1.13rem;
      }
      .btn-qrcode{
        width: .9rem;
        line-height: .28rem;
        height: .28rem;
        text-align: center;
        box-shadow: 0 2px 4px 0 rgba(67,107,196,0.50);
        border-radius: .14rem;
        font-size: .12rem;
        color: #FFFFFF;
        font-weight: bold;
        background-image: linear-gradient(270deg, #6398FF 0%, #3F80FF 100%);
        position: absolute;
        bottom: .15rem;
        right: .15rem;
      }
      .status-cancel{
        width: .8rem;
        height: .64rem;
        position: absolute;
        right: .14rem;
        bottom: .07rem;
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
  }
  .cancelpop{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,.1);
    .cancel-box{
      width: 2.7rem;
      height: 1.26rem;
      border-radius: .06rem;
      background: #FFFFFF;
      display: flex;
      flex-direction: column;
      .box-content{
        height: .86rem;
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: .14rem;
        color: #666666;
        padding-top: .31rem;
        box-sizing: border-box;
        border-bottom: .005rem solid #EBEBEB;
      }
      .box-bottom{
        flex: 1;
        width: 100%;
        display: flex;
        .bottom-item{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: .14rem;
          color: #666666;
          ~.bottom-item{
            color: #3B94F7;
            border-left: .005rem solid #EBEBEB;
          }
        }
      }
    }
  }
}
.theme-white{
  background: #FFFFFF;
}
.theme-blue{
  background-image: linear-gradient(0deg, #94B8FF 0%, #5D94FF 100%);
}
</style>



// WEBPACK FOOTER //
// src/pages/ReservationList.vue